import { render, staticRenderFns } from "./MediaIcons.vue?vue&type=template&id=f0ad68cc&"
import script from "./MediaIcons.vue?vue&type=script&lang=js&"
export * from "./MediaIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/carolinethuelarsen/Documents/development/ibg-screen-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0ad68cc')) {
      api.createRecord('f0ad68cc', component.options)
    } else {
      api.reload('f0ad68cc', component.options)
    }
    module.hot.accept("./MediaIcons.vue?vue&type=template&id=f0ad68cc&", function () {
      api.rerender('f0ad68cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/generic/MediaIcons.vue"
export default component.exports